var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"json"},[_c('vue-json',{attrs:{"path":'res',"data":_vm.json}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }